// extracted by mini-css-extract-plugin
export default {"view_job_mob_wrap":"_styles_view_job_mob_wrap__lyYlh"};